import Vue from 'vue';
import store from '@/store';
import router from '@/router'

const initVue = (element, Class) => {
    new Vue({
        render: h => h(Class, {
            props: { dataset: { ...element.dataset } },
        }),
        store,
        router,
    }).$mount(element);
};

export default function (elements, Class, type) {
    let elementsList = document.querySelectorAll(elements);

    for (let i = 0; i < elementsList.length; i += 1) {
        const element = elementsList[i];

        if (type === 'vue') {
            initVue(element, Class);
        }
    }
}